import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, EmptyState } from "@opensea/ui-kit";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { Button } from "../../components/Button";
import { useTrackError } from "../../providers/TrackErrorProvider";
import { FlowState } from "../../stores/flowStore";
export function BottomSheetErrorBoundaryFallback(t0) {
  const $ = _c(24);
  const {
    error,
    resetErrorBoundary
  } = t0;
  const t = useTranslations("wallet.BottomSheetError");
  const trackError = useTrackError();
  const [errorId, setErrorId] = useState();
  let t1;
  if ($[0] !== error || $[1] !== trackError) {
    t1 = () => {
      const {
        flow
      } = FlowState;
      const id = trackError(error, {
        extra: {
          flow
        },
        tags: {
          ...(flow?.type ? {
            flow: flow.type
          } : {})
        }
      });
      setErrorId(id);
    };
    $[0] = error;
    $[1] = trackError;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMountEffect(t1);
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle hidden={true}>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== errorId || $[8] !== t) {
    t4 = errorId && `${t("errorId")}: ${errorId}`;
    $[7] = errorId;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("somethingWentWrong");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <BottomSheetBody><EmptyState description={t4} title={t5} variant="no-data" /></BottomSheetBody>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("tryAgain");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== resetErrorBoundary || $[18] !== t7) {
    t8 = <BottomSheetFooter><Button className="w-fit" onClick={resetErrorBoundary} variant="secondary">{t7}</Button></BottomSheetFooter>;
    $[17] = resetErrorBoundary;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t6 || $[22] !== t8) {
    t9 = <>{t3}{t6}{t8}</>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}